module.exports = __webpack_public_path__ + "img/CL.a9acfa10.svg";